import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';
import { Couponset, LoyaltyMember, Schema, Store } from '../models/members-search.models';

export const LoadCustomerData = createAction('[Customer Data: All Customers]: Load Customer Data');

export const GetSchemasSuccess = createAction(
  '[Customer Data: All Customers]: Get Schemas Success',
  props<{ res: Schema[] }>(),
);

export const GetSchemasFailed = createAction(
  '[Customer Data: All Customers]: Get Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetStoresSuccess = createAction(
  '[Customer Data: All Customers]: Get Stores Success',
  props<{ res: Store[] }>(),
);

export const GetStoresFailed = createAction(
  '[Customer Data: All Customers]: Get Stores Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLoyaltyMembersSuccess = createAction(
  '[Customer Data: All Customers]: Get Loyalty Members Success',
  props<{ res: LoyaltyMember[] }>(),
);

export const GetLoyaltyMembersFailed = createAction(
  '[Customer Data: All Customers]: Get Loyalty Members Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCustomersSuccess = createAction(
  '[Customer Data: All Customers]: Get Customers Success',
  props<{ res: any }>(),
);

export const GetCustomersFailed = createAction(
  '[Customer Data: All Customers]: Get Customers Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponsetSuccess = createAction(
  '[Customer Data: All Customers]: Get Couponsets Success',
  props<{ res: Couponset[] }>(),
);

export const GetCouponsetFailed = createAction(
  '[Customer Data: All Customers]: Get Couponsets Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAttributeCodesSuccess = createAction(
  '[Customer Data: All Customers]: Get Attribute Codes Success',
  props<{ res: QcMerchantResponse }>(),
);

export const GetAttributeCodesFailed = createAction(
  '[Customer Data: All Customers]: Get Attribute Codes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const MainPanelStatusChanged = createAction(
  '[Customer Data: All Customers]: Main Panel Status Changed',
);

export const PersonalPanelStatusChanged = createAction(
  '[Customer Data: All Customers]: Personal Panel Status Changed',
);

export const OtherPanelStatusChanged = createAction(
  '[Customer Data: All Customers]: Other Panel Status Changed',
);

export const RegistrationDateFromChanged = createAction(
  '[Customer Data: All Customers]: Registration Date From Changed',
  props<{ registrationDateFrom: string }>(),
);

export const RegistrationDateUntilChanged = createAction(
  '[Customer Data: All Customers]: Registration Date Until Changed',
  props<{ registrationDateUntil: string }>(),
);

export const RegistrationDateFromCleared = createAction(
  '[Customer Data: All Customers]: Registration Date From Cleared',
);

export const RegistrationDateUntilCleared = createAction(
  '[Customer Data: All Customers]: Registration Date Until Cleared',
);

export const LastNameChanged = createAction(
  '[Customer Data: All Customers]: Last Name Changed',
  props<{ lastName: string }>(),
);

export const FirstNameChanged = createAction(
  '[Customer Data: All Customers]: First Name Changed',
  props<{ firstName: string }>(),
);

export const EmailChanged = createAction(
  '[Customer Data: All Customers]: Email Changed',
  props<{ email: string }>(),
);

export const MobileChanged = createAction(
  '[Customer Data: All Customers]: Mobile Changed',
  props<{ mobile: string }>(),
);

export const MemberTagChanged = createAction(
  '[Customer Data: All Customers]: Member Tag Changed',
  props<{ memberTag: number }>(),
);

export const QivosIDChanged = createAction(
  '[Customer Data: All Customers]: Qivos ID Changed',
  props<{ qivosID: string }>(),
);

export const AttributeTypeChanged = createAction(
  '[Customer Data: All Customers]: Attribute Type Changed',
  props<{ attributeType: string }>(),
);

export const AttributeNameChanged = createAction(
  '[Customer Data: All Customers]: Attribute Name Changed',
  props<{ attributeName: string }>(),
);

export const AttributeValueChanged = createAction(
  '[Customer Data: All Customers]: Attribute Value Changed',
  props<{ attributeValue: string | number }>(),
);

export const BoolAttributeValueChanged = createAction(
  '[Customer Data: All Customers]: Bool Attribute Value Changed',
);

export const AttributeDateFromChanged = createAction(
  '[Customer Data: All Customers]: Attribute Date From Changed',
  props<{ attributeDateFrom: string }>(),
);

export const AttributeDateUntilChanged = createAction(
  '[Customer Data: All Customers]: Attribute Date Until Changed',
  props<{ attributeDateUntil: string }>(),
);

export const ClearAttributeDateFrom = createAction(
  '[Customer Data: All Customers]: Clear Attribute Date From',
);

export const ClearAttributeDateUntil = createAction(
  '[Customer Data: All Customers]: Clear Attribute Date Until',
);

export const IncludeInactiveChanged = createAction(
  '[Customer Data: All Customers]: Include Inactive Changed',
);

export const SearchCustomers = createAction('[Customer Data: All Customers]: Search Customers');

export const SearchCustomersSuccess = createAction(
  '[Customer Data: All Customers]: Search Customers Success',
  props<{ res: QcResponseGrid }>(),
);

export const SearchCustomersFailed = createAction(
  '[Customer Data: All Customers]: Search Customers Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearCustomerFilters = createAction(
  '[Customer Data: All Customers]: Clear Customer Filters',
);

export const SearchAllCustomers = createAction(
  '[Customer Data: All Customers]: Search All Customers',
);

export const SearchCountAllCustomers = createAction(
  '[Customer Data: All Customers]: Search Count All Customers',
);

export const SearchCountAllCustomersSuccess = createAction(
  '[Customer Data: All Customers]: Search Count All Customers Success',
  props<{ res: number }>(),
);

export const SearchCountAllCustomersFailed = createAction(
  '[Customer Data: All Customers]: Search Count All Customers Failed',
  props<{ error: HttpErrorResponse }>(),
);
